module.exports = __webpack_public_path__ + "img/监控视频.083dbb51.png";